import { toNumOr, type Numeric } from '@/utils/numeric';

/**
 * Formats a duration in decimal hours as "Xh Ym".
 *
 * Negative values are clamped to zero so that tiny client/server clock-skew
 * right after clocking in never produces a nonsensical result like "-1h 60m".
 * Total minutes are computed before splitting into hours and minutes to prevent
 * rounding artefacts (e.g. 0.9999 h → "0h 60m" instead of "1h 0m").
 *
 * @example
 *   formatDuration(1.5)    // → "1h 30m"
 *   formatDuration(-0.001) // → "0h 0m"
 *   formatDuration(0.9999) // → "1h 0m"
 */
export function formatDuration(hours: Numeric | undefined): string {
  const totalMinutes = Math.round(Math.max(0, toNumOr(hours)) * 60);
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${wholeHours}h ${minutes}m`;
}
